import Vue from 'vue';
import InputText from './InputText.vue';
import InputNumber from './InputNumber.vue';
import InputSelect from './InputSelect.vue';
import InputCheckbox from './InputCheckbox.vue';
import InputRadio from './InputRadio.vue';
import InputFile from './InputFile.vue';

import './validation.plugin';

Vue.component('InputFile', InputFile);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component('InputSelect', InputSelect);
Vue.component('InputCheckbox', InputCheckbox);
Vue.component('InputRadio', InputRadio);
